'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002emath$002e$002dBig$002dInt from "./scala.math.-Big-Int.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$19$$anon$23(evaluator$29) {
  this.Lu = null;
  this.Lu = evaluator$29;
}
export { $c_Lsamples_Persons$package$$anon$19$$anon$23 as $c_Lsamples_Persons$package$$anon$19$$anon$23 };
$p = $c_Lsamples_Persons$package$$anon$19$$anon$23.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$19$$anon$23;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$19$$anon$23() {
}
export { $h_Lsamples_Persons$package$$anon$19$$anon$23 as $h_Lsamples_Persons$package$$anon$19$$anon$23 };
$h_Lsamples_Persons$package$$anon$19$$anon$23.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lu.h();
  return ((v instanceof $j_scala$002emath$002e$002dBig$002dInt.$c_s_math_BigInt) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$19$$anon$23 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$19$$anon$23, "samples.Persons$package$$anon$19$$anon$23", ({
  pD: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$19$$anon$23 as $d_Lsamples_Persons$package$$anon$19$$anon$23 };
